/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Statut de la réponse au questionnaire médical
 * @export
 * @interface MedicalSurveyResponseProcessDto
 */
export interface MedicalSurveyResponseProcessDto {
    /**
     * 
     * @type {boolean}
     * @memberof MedicalSurveyResponseProcessDto
     */
    isProcessed: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalSurveyResponseProcessDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalSurveyResponseProcessDto
     */
    statusLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalSurveyResponseProcessDto
     */
    explanatoryMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalSurveyResponseProcessDto
     */
    isAccepted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalSurveyResponseProcessDto
     */
    requiresBPA?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MedicalSurveyResponseProcessDto
     */
    processedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSurveyResponseProcessDto
     */
    details?: string | null;
}

/**
 * Check if a given object implements the MedicalSurveyResponseProcessDto interface.
 */
export function instanceOfMedicalSurveyResponseProcessDto(value: object): value is MedicalSurveyResponseProcessDto {
    if (!('isProcessed' in value) || value['isProcessed'] === undefined) return false;
    return true;
}

export function MedicalSurveyResponseProcessDtoFromJSON(json: any): MedicalSurveyResponseProcessDto {
    return MedicalSurveyResponseProcessDtoFromJSONTyped(json, false);
}

export function MedicalSurveyResponseProcessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSurveyResponseProcessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isProcessed': json['isProcessed'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusLabel': json['statusLabel'] == null ? undefined : json['statusLabel'],
        'explanatoryMessage': json['explanatoryMessage'] == null ? undefined : json['explanatoryMessage'],
        'isAccepted': json['isAccepted'] == null ? undefined : json['isAccepted'],
        'requiresBPA': json['requiresBPA'] == null ? undefined : json['requiresBPA'],
        'processedDate': json['processedDate'] == null ? undefined : (new Date(json['processedDate'])),
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function MedicalSurveyResponseProcessDtoToJSON(json: any): MedicalSurveyResponseProcessDto {
    return MedicalSurveyResponseProcessDtoToJSONTyped(json, false);
}

export function MedicalSurveyResponseProcessDtoToJSONTyped(value?: MedicalSurveyResponseProcessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isProcessed': value['isProcessed'],
        'status': value['status'],
        'statusLabel': value['statusLabel'],
        'explanatoryMessage': value['explanatoryMessage'],
        'isAccepted': value['isAccepted'],
        'requiresBPA': value['requiresBPA'],
        'processedDate': value['processedDate'] == null ? undefined : ((value['processedDate'] as any).toISOString()),
        'details': value['details'],
    };
}

